//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import {
  orderDetail,
  cancelOrder,
  userInfo,
  payByPoint
} from '../../service/index'
import Api from '../../utils/config'

export default {
  data() {
    return {
      orderDetail: {},
      userInfo: {},
      orderGoodsList: [],
      payment: Api.payment,
      paymentMb: Api.paymentMb,
      dialogVisible: false,
    }
  },
  created() {
    const orderId = this.$route.params.orderId
    this.getOrderDetail(orderId)
    this.getUserInfo()
    this.keepLang()
  },
  computed: {
    ...mapState(['global'])
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    },

    async getUserInfo() {
      const res = await userInfo(this.$route.query.cid)
      if (res.status === 0) {
        this.userInfo = res.data
      }
    },

    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },

    async getOrderDetail(orderId) {
      const res = await orderDetail(orderId)
      if (res.status === 0) {
        this.orderDetail = res.data
        this.orderGoodsList = res.data.items
      }
    },


    async payPoint(orderId) {
      const res = await payByPoint(orderId)
      console.log('res',res)
      if (res.status == 0) {
        this.$router.push({
          name: 'orderDetail',
          params: {
            orderId: orderId
          },
          query: {
            cid: this.$route.query.cid
          }
        });
      } else if (res.status == 2) {
        this.$message({
          message: this.$t('pointPay.notenough'),
          type: 'error'
        })

      } else if (res.status == 3) {
        this.$message({
          message: this.$t('pointPay.already'),
          type: 'error'
        })

      } else {
        this.$message({
          message: this.$t('pointPay.retry'),
          type: 'error'
        })

      }

    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/pay/Pointpay.vue